import { css } from 'styled-components';
import { theme } from "../../theme";
export var hitTarget = function hitTarget(_ref) {
  var _ref$padX = _ref.padX,
      padX = _ref$padX === void 0 ? 0 : _ref$padX,
      _ref$padY = _ref.padY,
      padY = _ref$padY === void 0 ? 0 : _ref$padY,
      _ref$radius = _ref.radius,
      radius = _ref$radius === void 0 ? 0 : _ref$radius;
  return css(["position:relative;cursor:pointer;&:before{content:'';position:absolute;top:-", "px;bottom:-", "px;left:-", "px;right:-", "px;border-radius:", ";}"], padY, padY, padX, padX, theme.radii[radius]);
};